/* tslint:disable:import-spacing no-inferrable-types
variable-name align no-trailing-whitespace component-class-suffix
no-string-literal component-selector
*/

import {Track, TrackType} from '@/models/scenario/track';
import {DecisionPoint}    from '@/models/scenario/decision.point';

/**
 *
 * @class TrackIngress
 *
 * @brief helper class to pair up a Decision Point and a chose Track on either
 * side.
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      July 2020
 *
 */
export class TrackIngress {

  /** the location where we are picking a track */
  public location: DecisionPoint = null;

  /** the chosen track */
  public track: Track = null;

  /** standard constructor */
  constructor(dp: DecisionPoint, track: Track = null) {

    this.location = dp;
    this.track    = track;
  }

  /** helper to give a quick string summary */
  public asString(): string {

    if (this.location === null) {

      return '- -';
    }

    if (this.track === null) {

      return this.location.asString() + ' M0';
    }

    return this.location.asString() + ' ' + Track.typeToString(this.track._type) + this.track._track;
  }
}
